import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import useAdminRole, { ROLE_LEVEL } from './useAdminRole';

export default function AdminGuard({ minRole = 'support', children }) {
  const { currentUser, loading: authLoading } = useAuth();
  const { role, loading } = useAdminRole();
  if (authLoading || loading) {
    return <div role="status" className="p-8 text-[#5F5B50]">Chargement…</div>;
  }
  if (!currentUser) return <Navigate to="/login" replace />;
  const need = ROLE_LEVEL[minRole] || ROLE_LEVEL.owner;
  if (!role || ROLE_LEVEL[role] < need) return <Navigate to="/" replace />;
  return children;
}
